
export default {
  props: {
    page: {
      type: Object,
      required: true,
    },

    bgWhite: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isHover: false,
    }
  },
}
